/**
 * Frontastic Dependency Injection for JavaScript Stack
 *
 * Use this file to overwrite any dependency in Frontastic which is injected
 * using the ComponentInjector.
 */

/* eslint-disable no-unused-vars */
import SportscraftAppWrapper from './app/SportscraftAppWrapper';
import NodeConfigurationSchema from './nodeConfiguration.json';
import { CommonReducer } from './redux/common';
import { UiReducer } from './redux/loader/ui';
import * as WishlistLoading from './redux/loader/wishlist-loading';
import ComponentInjector from '@frontastic/catwalk/src/js/app/injector';
import TagManager from '@srcDS/js/classes/TagManager';
import Nosto from '@srcDS/js/classes/Nosto';

// import matchMedia from '@srcDS/polyfills/matchMedia';
import React from 'react';

/* eslint-enable no-unused-vars */

const PayLater = function () {};

const paylaterInitialGlobalState = {
  payLaterIsOpen: false,
  sizeGuideOpen: false,
  sizeGuideProductData: {},
  sizeGuideAvailableIds: [],
  storeLocatorOpen: false,
};

const KeywordsOverride = () => null;

PayLater.handleAction = (globalState = paylaterInitialGlobalState, action) => {
  switch (action.type) {
    case 'open-paylater':
      return {
        ...globalState,
        payLaterIsOpen: true,
      };
    case 'close-paylater':
      return {
        ...globalState,
        payLaterIsOpen: false,
      };
    case 'availableIds-sizeguide':
      return {
        ...globalState,
        sizeGuideAvailableIds: [ ...action.availableCategoryIds ],
      };
    case 'open-sizeguide':
      return {
        ...globalState,
        sizeGuideOpen: true,
        sizeGuideProductData: {
          ...action.data,
        },
      };
    case 'close-sizeguide':
      return {
        ...globalState,
        sizeGuideOpen: false,
      };
    case 'open-storelocator':
      return {
        ...globalState,
        storeLocatorOpen: true,
      };
    case 'close-storelocator':
      return {
        ...globalState,
        storeLocatorOpen: false,
      };
    default:
  }

  return globalState;
};

const GtmAnalytics = function (data) {};

const CustomScrollContainer = ({ children }) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>{children}</>
);

let userState = [];
let pageData = [];
let cartData = [];

GtmAnalytics.handleAction = async (globalState = {}, action) => {
  switch (action.type) {
    case 'ApiBundle.Api.context.success':
      userState.push(action.data);
      return globalState;
    case 'Frontend.Tracking.PageView':
      pageData.push(action.data);
      Nosto.nostoPageView(action.data);
      if (!userState) return;
      if (userState[0].session.loggedIn) {
        await TagManager.customerDetails({
          ...userState[0].session,
          account: {
            ...userState[0].session.account,
            phone:
              userState[0].session.account?.projectSpecificData?.phone ||
              pageData?.data?.stream?.__master?.shippingAddress?.phone,
          },
        });
      }
      await TagManager.virtualPageView({
        pageData: action.data,
        userData: userState && userState[0],
      });
      cartData?.length &&
        TagManager.cartContentsPush(cartData && cartData[0].cart);
      return globalState;
    case 'UI.miniCartToggle':
      if (action.data === true) {
        TagManager.virtualPageView({
          customUrl: window.location.pathname + '#minicart',
          pageData: { ...pageData[0] },
          userData: userState && userState[0],
        });
      }
      return globalState;
    case 'Frontastic.AccountApi.Api.register.success':
      TagManager.createAccountEvent(action.data);
      return globalState;
    case 'Frontastic.AccountApi.Api.logout':
      TagManager.logoutEvent();
      return globalState;
    case 'CartApi.Cart.get.success':
      cartData = [];
      cartData.push(action.data);
      TagManager.cartContentsPush(action.data.cart);
      return globalState;
    case 'CartApi.Cart.update.success':
      TagManager.cartContentsPush(action.data.cart);
      return globalState;
    default:
    // Do nothing for other actions
  }

  return globalState;
};

ComponentInjector.set('AtomsNotification', () => null);
ComponentInjector.set('ScrollbarContainer', CustomScrollContainer);
ComponentInjector.set('AppContainer', SportscraftAppWrapper);
ComponentInjector.set('NodeConfigurationSchema', NodeConfigurationSchema);
ComponentInjector.set('Node.Meta.Keywords', KeywordsOverride);
ComponentInjector.registerReducer('gtm-analytics', GtmAnalytics.handleAction);
ComponentInjector.registerReducer('demo-saba', PayLater.handleAction);
ComponentInjector.registerReducer('demo-ui', UiReducer.handleAction);
ComponentInjector.registerReducer('demo-common', CommonReducer.handleAction);
ComponentInjector.registerReducer(
  'wishlist-loading-skus',
  WishlistLoading.handleAction,
);

// This is just a dummy function that can be called from the client code so the import won't be optimized away.
// It would be nice to manipulate the ComponentInjector within this function
// but the function call is invoked to late and therefore the components won't be overridden on time.
export default function injection() {
}
